import SEOPage from "./SEOPage";

export default function TestTubeBabyCentreAmbala() {
  return (
    <SEOPage
      title="Test Tube Baby Centre in Ambala | Amaanat IVF"
      description="Best Test Tube Baby Centre in Ambala offering advanced IVF treatment, ICSI, embryo transfer and infertility solutions."
      canonical="https://amaanativf.com/test-tube-baby-centre-in-ambala"
      heading="Test Tube Baby Centre in Ambala"
      focusKeyword="Test Tube Baby Centre in Ambala"
    />
  );
}